import { render } from "./Learning.vue?vue&type=template&id=53d59162"
import script from "./Learning.vue?vue&type=script&lang=ts"
export * from "./Learning.vue?vue&type=script&lang=ts"
script.render = render

export default script